var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { key: _vm.renderCount, attrs: { id: "archive" } },
    [
      _c(
        "AppBreadCrumb",
        {
          attrs: {
            paths: [{ title: _vm.$t("message.archive") }],
            select: true,
            "show-subjects": true,
          },
        },
        [
          _c(
            "div",
            { staticStyle: { display: "flex", "align-items": "center" } },
            [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.timeSelect,
                      expression: "timeSelect",
                    },
                  ],
                  attrs: { id: "time-select" },
                  on: {
                    change: function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.timeSelect = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                  },
                },
                [
                  _c("option", { attrs: { value: "today" } }, [
                    _vm._v(_vm._s(_vm.$t("time.today"))),
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "yesterday" } }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("time.yesterday")) +
                        "\n                "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "current-week" } }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("time.currentWeek")) +
                        "\n                "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "last-week" } }, [
                    _vm._v(_vm._s(_vm.$t("time.lastWeek"))),
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "current-month" } }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("time.currentMonth")) +
                        "\n                "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "last-month" } }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("time.lastMonth")) +
                        "\n                "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "last-30" } }, [
                    _vm._v(_vm._s(_vm.$t("time.last30Day"))),
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "all-time" } }, [
                    _vm._v(_vm._s(_vm.$t("time.allTime"))),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: { followCursor: true, placement: "bottom-end" },
                      expression:
                        "{ followCursor: true, placement: 'bottom-end' }",
                    },
                  ],
                  staticClass: "custom-checkbox3",
                  staticStyle: { width: "100px", "max-width": "133px" },
                  attrs: { content: _vm.$t("message.showFeedbackHistory") },
                },
                [
                  _c(
                    "a-switch",
                    {
                      attrs: { size: "small" },
                      model: {
                        value: _vm.filterDescription,
                        callback: function ($$v) {
                          _vm.filterDescription = $$v
                        },
                        expression: "filterDescription",
                      },
                    },
                    [
                      _c("a-icon", {
                        attrs: { slot: "checkedChildren", type: "check" },
                        slot: "checkedChildren",
                      }),
                      _vm._v(" "),
                      _c("a-icon", {
                        attrs: { slot: "unCheckedChildren", type: "close" },
                        slot: "unCheckedChildren",
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.$t("message.feedback")))]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: { followCursor: true, placement: "bottom-end" },
                      expression:
                        "{ followCursor: true, placement: 'bottom-end' }",
                    },
                  ],
                  staticClass: "custom-checkbox3",
                  staticStyle: { width: "100px", "max-width": "133px" },
                  attrs: { content: _vm.$t("message.filterVideoCall") },
                },
                [
                  _c(
                    "a-switch",
                    {
                      attrs: { size: "small" },
                      model: {
                        value: _vm.filterVideoCall,
                        callback: function ($$v) {
                          _vm.filterVideoCall = $$v
                        },
                        expression: "filterVideoCall",
                      },
                    },
                    [
                      _c("a-icon", {
                        attrs: { slot: "checkedChildren", type: "check" },
                        slot: "checkedChildren",
                      }),
                      _vm._v(" "),
                      _c("a-icon", {
                        attrs: { slot: "unCheckedChildren", type: "close" },
                        slot: "unCheckedChildren",
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.$t("message.videoCalls")))]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: { followCursor: true, placement: "bottom-end" },
                      expression:
                        "{ followCursor: true, placement: 'bottom-end' }",
                    },
                  ],
                  staticClass: "custom-checkbox3",
                  staticStyle: { width: "100px", "max-width": "133px" },
                  attrs: { content: _vm.$t("message.filterLostChat") },
                },
                [
                  _c(
                    "a-switch",
                    {
                      attrs: { size: "small" },
                      model: {
                        value: _vm.filterLostChats,
                        callback: function ($$v) {
                          _vm.filterLostChats = $$v
                        },
                        expression: "filterLostChats",
                      },
                    },
                    [
                      _c("a-icon", {
                        attrs: { slot: "checkedChildren", type: "check" },
                        slot: "checkedChildren",
                      }),
                      _vm._v(" "),
                      _c("a-icon", {
                        attrs: { slot: "unCheckedChildren", type: "close" },
                        slot: "unCheckedChildren",
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.$t("message.filterLost")))]),
                ],
                1
              ),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "b-container",
        { staticClass: "mt-3", attrs: { fluid: "" } },
        [
          _c(
            "b-row",
            { staticClass: "custom-row" },
            [
              _c(
                "b-col",
                [
                  _c(
                    "b-form-group",
                    {
                      staticClass: "custom-input mb-0",
                      attrs: {
                        id: "start-date-input-group",
                        label: _vm.$t("message.first"),
                        "label-for": "start-date-input",
                        "label-sr-only": "",
                      },
                    },
                    [
                      _c("datetime", {
                        attrs: {
                          "max-datetime": _vm.maxDate,
                          "min-datetime": _vm.lastFiveYear,
                          phrases: _vm.phrases,
                          placeholder: _vm.$t("message.startDate"),
                          auto: "",
                          "input-class": "form-control rounded-0",
                          "input-id": "start-date-input",
                          type: "datetime",
                        },
                        model: {
                          value: _vm.startDate,
                          callback: function ($$v) {
                            _vm.startDate = $$v
                          },
                          expression: "startDate",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "pl-3" },
                [
                  _c(
                    "b-form-group",
                    {
                      staticClass: "custom-input mb-0",
                      attrs: {
                        id: "end-date-input-group",
                        label: _vm.$t("message.last"),
                        "label-for": "end-date-input",
                        "label-sr-only": "",
                      },
                    },
                    [
                      _c("datetime", {
                        attrs: {
                          "max-datetime": _vm.maxDate,
                          "min-datetime": _vm.startDate,
                          phrases: _vm.phrases,
                          placeholder: _vm.$t("message.endDate"),
                          auto: "",
                          "input-class": "form-control rounded-0",
                          "input-id": "end-date-input",
                          type: "datetime",
                        },
                        model: {
                          value: _vm.endDate,
                          callback: function ($$v) {
                            _vm.endDate = $$v
                          },
                          expression: "endDate",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "pl-3" },
                [
                  _c(
                    "b-form-group",
                    {
                      staticClass: "custom-input mb-0",
                      attrs: {
                        id: "query-input-group",
                        label: _vm.$t("message.query"),
                        "label-for": "query-input",
                        "label-sr-only": "",
                      },
                    },
                    [
                      _c("b-form-input", {
                        attrs: {
                          id: "query-input",
                          placeholder: _vm.$t("message.query"),
                          name: "query",
                        },
                        model: {
                          value: _vm.query,
                          callback: function ($$v) {
                            _vm.query = $$v
                          },
                          expression: "query",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "pl-3" },
                [
                  _c(
                    "b-form-group",
                    { staticClass: "custom-input mb-1" },
                    [
                      _c("multiselect", {
                        attrs: {
                          multiple: true,
                          options: _vm.multiSelectOptions,
                          placeholder: _vm.$t("message.allContacts"),
                          label: "name",
                          "track-by": "name",
                          "select-label": "",
                        },
                        on: { select: _vm.valueIds },
                        model: {
                          value: _vm.multiSelectValue,
                          callback: function ($$v) {
                            _vm.multiSelectValue = $$v
                          },
                          expression: "multiSelectValue",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("br"),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "pl-3" },
                [
                  _c(
                    "b-form-group",
                    {
                      staticClass: "custom-input mb-0",
                      attrs: {
                        id: "query-input-group2",
                        label: "Sorgu",
                        "label-for": "query-input",
                        "label-sr-only": "",
                      },
                    },
                    [
                      _c(
                        "b-form-select",
                        {
                          staticClass: "mb-3",
                          model: {
                            value: _vm.selectedUser,
                            callback: function ($$v) {
                              _vm.selectedUser = $$v
                            },
                            expression: "selectedUser",
                          },
                        },
                        [
                          _c("option", { domProps: { value: null } }, [
                            _vm._v(
                              _vm._s(_vm.$t("message.allUsers")) + " + Chatbot"
                            ),
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "reps" } }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.$t("message.allUsers")) +
                                "\n                        "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "chatBot" } }, [
                            _vm._v("ChatBot"),
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.usersFilter.data, function (item) {
                            return _c(
                              "option",
                              { key: item._id, domProps: { value: item._id } },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(item.name) +
                                    "\n                        "
                                ),
                              ]
                            )
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("b-col", { staticClass: "pl-3" }, [
                _c(
                  "div",
                  { staticClass: "custom-input" },
                  [
                    _c("a-rate", {
                      attrs: { "allow-clear": true },
                      model: {
                        value: _vm.point,
                        callback: function ($$v) {
                          _vm.point = $$v
                        },
                        expression: "point",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "custom-row" },
            [
              _c(
                "b-col",
                {
                  class: {
                    "col-lg-5": !_vm.wideScreen,
                    "col-lg-4": _vm.wideScreen,
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "scrollable",
                      attrs: { id: "conversation-list" },
                      on: { scroll: _vm.handleScroll },
                    },
                    [
                      _c(
                        "b-table",
                        {
                          attrs: {
                            id: "visitor-list-table",
                            fields: _vm.fields,
                            items: _vm.visitors.data,
                            "tbody-tr-class": _vm.rowClass,
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "cell(actions)",
                              fn: function (data, item) {
                                return [
                                  _c(
                                    "div",
                                    {
                                      key: data.item._id,
                                      staticClass: "info",
                                      on: {
                                        click: function ($event) {
                                          return _vm.view(data.item._id)
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "custom-card userInfo" },
                                        [
                                          _c("b", [
                                            _vm._v(
                                              _vm._s(data.item.fullname || "-")
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("b", [
                                            _vm._v(
                                              "\n                                        " +
                                                _vm._s(
                                                  _vm.getEmail(data.item)
                                                ) +
                                                "\n                                    "
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("b", [
                                            _vm._v(
                                              _vm._s(
                                                (data.item.users.length > 0
                                                  ? data.item.users.slice(0, 3)
                                                  : [data.item.connectedUser]
                                                )
                                                  .map(function (x) {
                                                    return _vm.getUserHelper(x)
                                                  })
                                                  .join(", ")
                                              )
                                            ),
                                          ]),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "custom-card back chatMeta",
                                        },
                                        [
                                          _c("b", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("date")(
                                                  data.item.createdDate,
                                                  "D/M/YY HH:m:s"
                                                )
                                              )
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "b",
                                            [
                                              _c(
                                                "PassedTimeCounterTimeFormat",
                                                {
                                                  attrs: {
                                                    id: data.item._id,
                                                    date: data.item
                                                      .connectedDate,
                                                    endDate:
                                                      data.item.destroyedDate,
                                                    shortFormat: true,
                                                  },
                                                }
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b",
                                            [
                                              _c("a-rate", {
                                                style: {
                                                  color: data.item.description
                                                    ? "orangered"
                                                    : "#fadb14",
                                                },
                                                attrs: {
                                                  "default-value":
                                                    data.item.point || 0,
                                                  disabled: "",
                                                  size: "12",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ]),
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "text-center text-danger my-2",
                              attrs: { slot: "table-busy" },
                              slot: "table-busy",
                            },
                            [_c("b-spinner", { staticClass: "align-middle" })],
                            1
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.isBusy
                        ? _c(
                            "div",
                            { staticClass: "text-center text-info my-3" },
                            [_c("b-spinner", { staticClass: "align-middle" })],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.selectedHistory.messages.length
                        ? _c(
                            "div",
                            { staticClass: "text-center text-info my-3" },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.$t("message.chatNotFound")) +
                                  "\n                    "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "pl-3",
                  class: {
                    "col-lg-7": !_vm.wideScreen,
                    "col-lg-5": _vm.wideScreen,
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "scrollable",
                      staticStyle: { overflow: "hidden" },
                    },
                    [
                      _vm.selectedHistory.id && !_vm.wideScreen
                        ? _c(
                            "div",
                            { staticClass: "userMetaInfo bg-white" },
                            [
                              _c("b-col", { staticStyle: { margin: "10px" } }, [
                                _c("div", { staticClass: "userInfo" }, [
                                  _c("div", { staticClass: "userInfo first" }, [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(_vm.$t("message.fullName")) +
                                        "\n                                "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "tippy",
                                          rawName: "v-tippy",
                                          value: {
                                            followCursor: true,
                                            placement: "bottom-end",
                                            theme: _vm.isDarkMode
                                              ? "light-border"
                                              : "google",
                                          },
                                          expression:
                                            "{\n                                        followCursor: true,\n                                        placement: 'bottom-end',\n                                        theme: isDarkMode ? 'light-border' : 'google',\n                                    }",
                                        },
                                      ],
                                      staticClass: "userInfo sec",
                                      attrs: {
                                        content:
                                          _vm.selectedHistory.conversation
                                            .fullname,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(
                                            _vm.selectedHistory.conversation
                                              .fullname
                                          ) +
                                          "\n                                "
                                      ),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "userInfo" }, [
                                  _c("div", { staticClass: "userInfo first" }, [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(_vm.$t("message.email")) +
                                        "\n                                "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "tippy",
                                          rawName: "v-tippy",
                                          value: {
                                            followCursor: true,
                                            placement: "bottom-end",
                                            theme: _vm.isDarkMode
                                              ? "light-border"
                                              : "google",
                                          },
                                          expression:
                                            "{\n                                        followCursor: true,\n                                        placement: 'bottom-end',\n                                        theme: isDarkMode ? 'light-border' : 'google',\n                                    }",
                                        },
                                      ],
                                      staticClass: "userInfo sec",
                                      attrs: {
                                        content:
                                          _vm.selectedHistory.conversation
                                            .email,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(
                                            _vm.selectedHistory.conversation
                                              .email
                                          ) +
                                          "\n                                "
                                      ),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "userInfo" }, [
                                  _c("div", { staticClass: "userInfo first" }, [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(_vm.$t("message.department")) +
                                        "\n                                "
                                    ),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "userInfo" }, [
                                  _c("div", { staticClass: "userInfo first" }, [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(
                                          _vm.$t("message.representative")
                                        ) +
                                        "\n                                "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "userInfo sec" }, [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(
                                          (_vm.selectedHistory.conversation
                                            .users.length > 0
                                            ? _vm.selectedHistory.conversation.users.slice(
                                                0,
                                                3
                                              )
                                            : [
                                                _vm.selectedHistory.conversation
                                                  .connectedUser,
                                              ]
                                          )
                                            .map(function (x) {
                                              return _vm.getUserHelper(x)
                                            })
                                            .join(", ")
                                        ) +
                                        "\n                                "
                                    ),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "d-flex" }, [
                                  _c("div", { staticClass: "userInfo" }, [
                                    _c(
                                      "div",
                                      { staticClass: "userInfo first" },
                                      [
                                        _vm._v(
                                          "\n                                        " +
                                            _vm._s(_vm.$t("message.country")) +
                                            "\n                                    "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "userInfo sec" }, [
                                      _vm._v(
                                        "\n                                        " +
                                          _vm._s(
                                            _vm.$_.get(
                                              _vm.selectedHistory,
                                              "conversation.visitor.country",
                                              "-"
                                            )
                                          ) +
                                          "\n                                    "
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "userInfo pl-3" }, [
                                    _c(
                                      "div",
                                      { staticClass: "userInfo first" },
                                      [
                                        _vm._v(
                                          "\n                                        " +
                                            _vm._s(_vm.$t("message.language")) +
                                            "\n                                    "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "userInfo sec" }, [
                                      _vm._v(
                                        "\n                                        " +
                                          _vm._s(
                                            _vm.selectedHistory.conversation
                                              .languageCode
                                          ) +
                                          "\n                                    "
                                      ),
                                    ]),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "userInfo" }, [
                                  _c("div", { staticClass: "userInfo first" }, [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(_vm.$t("message.osAndBrowser")) +
                                        "\n                                "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "userInfo sec" }, [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(
                                          _vm.$_.get(
                                            _vm.selectedHistory,
                                            "conversation.visitor.os"
                                          )
                                        ) +
                                        "\n                                    " +
                                        _vm._s(
                                          _vm.$_.get(
                                            _vm.selectedHistory,
                                            "conversation.visitor.browser"
                                          )
                                        ) +
                                        "\n                                "
                                    ),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "userInfo" }, [
                                  _c("div", { staticClass: "userInfo first" }, [
                                    _vm._v("IP"),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "userInfo sec" }, [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(
                                          _vm.$_.get(
                                            _vm.selectedHistory,
                                            "conversation.visitor.ipAddress"
                                          )
                                        ) +
                                        "\n                                "
                                    ),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "userInfo" }, [
                                  _c("div", { staticClass: "userInfo first" }, [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(_vm.$t("message.chatId")) +
                                        "\n                                "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "userInfo sec" }, [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(
                                          _vm.selectedHistory.conversation._id
                                        ) +
                                        "\n                                "
                                    ),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "userInfo" }, [
                                  _c("div", { staticClass: "userInfo first" }, [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(
                                          _vm.$t(
                                            "message.customerClientVersion"
                                          )
                                        ) +
                                        "\n                                "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "userInfo sec" }, [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(
                                          _vm.$_.get(
                                            _vm.selectedHistory,
                                            "conversation.visitor.version.versionStr",
                                            "-"
                                          )
                                        ) +
                                        "\n                                "
                                    ),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _vm.selectedHistory.conversation.description
                                  ? _c("div", { staticClass: "userInfo" }, [
                                      _c(
                                        "div",
                                        { staticClass: "userInfo first" },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(
                                                _vm.$t(
                                                  "message.visitorFeedback"
                                                )
                                              ) +
                                              "\n                                "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "userInfo sec" },
                                        [
                                          _c(
                                            "p",
                                            {
                                              directives: [
                                                {
                                                  name: "b-modal",
                                                  rawName:
                                                    "v-b-modal.visitor-message",
                                                  modifiers: {
                                                    "visitor-message": true,
                                                  },
                                                },
                                              ],
                                              staticStyle: {
                                                "word-wrap": "break-word",
                                                overflow: "hidden",
                                                "text-overflow": "ellipsis",
                                                display: "-webkit-box",
                                                "-webkit-box-orient":
                                                  "vertical",
                                                "-webkit-line-clamp": "3",
                                                "word-break": "break-all",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(
                                                    _vm.selectedHistory
                                                      .conversation.description
                                                  ) +
                                                  "\n                                    "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ])
                                  : _vm._e(),
                              ]),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                [
                                  _c("b-col", [
                                    _c(
                                      "h5",
                                      {
                                        staticClass:
                                          "text-center pointer text-info my-2",
                                      },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(_vm.$t("message.userInfo")) +
                                            "\n                                    "
                                        ),
                                        _c(
                                          "md-icon",
                                          { staticClass: "text-info" },
                                          [_vm._v("expand_more")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.getMessages().length &&
                      !_vm.isLoading &&
                      _vm.selectedHistory.conversation._id !== null
                        ? _c("MessageList", {
                            attrs: {
                              "always-scroll-to-bottom": false,
                              colors: _vm.colors,
                              messages: _vm.getMessages(),
                              participants: _vm.getParticipants(),
                              "scroll-top": true,
                            },
                          })
                        : _c(
                            "div",
                            {
                              staticClass:
                                "bg-light border px-3 py-1 px-3 text-center",
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.$t("message.noMessageInChat")) +
                                  "\n                    "
                              ),
                            ]
                          ),
                      _vm._v(" "),
                      _vm.isLoading
                        ? _c(
                            "div",
                            { staticClass: "text-center text-danger my-2" },
                            [_c("b-spinner", { staticClass: "align-middle" })],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _vm.selectedHistory.id && _vm.wideScreen
                ? _c(
                    "b-col",
                    {
                      staticClass: "col-lg-3 bg-white scrollable",
                      attrs: { id: "information-list2" },
                    },
                    [
                      _c("div", { staticClass: "headtitle" }, [
                        _vm._v(_vm._s(_vm.$t("message.userInfo"))),
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        Array.isArray(
                          _vm.selectedHistory.conversation.customLoginInfos
                        ) &&
                        _vm.selectedHistory.conversation.customLoginInfos.length
                          ? _c(
                              "div",
                              _vm._l(
                                _vm.getCustomLoginInfos(),
                                function (inputValue) {
                                  return _c(
                                    "div",
                                    { staticClass: "userInfo" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "userInfo first" },
                                        [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(inputValue.name) +
                                              "\n                            "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "userInfo sec" },
                                        [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(inputValue.value) +
                                              "\n                            "
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                }
                              ),
                              0
                            )
                          : _c("div", [
                              _c("div", { staticClass: "userInfo" }, [
                                _c("div", { staticClass: "userInfo first" }, [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(_vm.$t("message.fullName")) +
                                      "\n                            "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "userInfo sec" }, [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.selectedHistory.conversation
                                          .fullname
                                      ) +
                                      "\n                            "
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "userInfo" }, [
                                _c("div", { staticClass: "userInfo first" }, [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(_vm.$t("message.email")) +
                                      "\n                            "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "userInfo sec" }, [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.selectedHistory.conversation.email
                                      ) +
                                      "\n                            "
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "userInfo" }, [
                                _c("div", { staticClass: "userInfo first" }, [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(_vm.$t("message.department")) +
                                      "\n                            "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "userInfo sec" }, [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.getSubjectName(
                                          _vm.selectedHistory.conversation
                                            .subject
                                        )
                                      ) +
                                      "\n                            "
                                  ),
                                ]),
                              ]),
                            ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "userInfo" }, [
                          _c("div", { staticClass: "userInfo first" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.$t("message.representative")) +
                                "\n                        "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "userInfo sec" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  (_vm.selectedHistory.conversation.users
                                    .length > 0
                                    ? _vm.selectedHistory.conversation.users.slice(
                                        0,
                                        3
                                      )
                                    : [
                                        _vm.selectedHistory.conversation
                                          .connectedUser,
                                      ]
                                  )
                                    .map(function (x) {
                                      return _vm.getUserHelper(x)
                                    })
                                    .join(", ")
                                ) +
                                "\n                        "
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "d-flex" }, [
                          _c("div", { staticClass: "userInfo" }, [
                            _c("div", { staticClass: "userInfo first" }, [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(_vm.$t("message.country")) +
                                  "\n                            "
                              ),
                            ]),
                            _vm._v(" "),
                            _vm.getCountryCode(
                              _vm.$_.get(
                                _vm.selectedHistory,
                                "conversation.visitor.country"
                              )
                            )
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "userInfo sec",
                                    staticStyle: { "padding-top": "2px" },
                                  },
                                  [
                                    _c("country-flag", {
                                      directives: [
                                        {
                                          name: "tippy",
                                          rawName: "v-tippy",
                                          value: {
                                            followCursor: true,
                                            placement: "bottom-end",
                                            theme: _vm.isDarkMode
                                              ? "light-border"
                                              : "google",
                                          },
                                          expression:
                                            "{\n                                        followCursor: true,\n                                        placement: 'bottom-end',\n                                        theme: isDarkMode ? 'light-border' : 'google',\n                                    }",
                                        },
                                      ],
                                      attrs: {
                                        content: _vm.getCountryName(
                                          _vm.$_.get(
                                            _vm.selectedHistory,
                                            "conversation.visitor.country"
                                          )
                                        ),
                                        country: _vm.getCountryCode(
                                          _vm.$_.get(
                                            _vm.selectedHistory,
                                            "conversation.visitor.country"
                                          )
                                        ),
                                        size: "normal",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "tippy",
                                        rawName: "v-tippy",
                                        value: {
                                          followCursor: true,
                                          placement: "bottom-end",
                                          theme: _vm.isDarkMode
                                            ? "light-border"
                                            : "google",
                                        },
                                        expression:
                                          "{\n                                    followCursor: true,\n                                    placement: 'bottom-end',\n                                    theme: isDarkMode ? 'light-border' : 'google',\n                                }",
                                      },
                                    ],
                                    staticClass: "userInfo sec",
                                    attrs: {
                                      content: _vm.getCountryName(
                                        _vm.$_.get(
                                          _vm.selectedHistory,
                                          "conversation.visitor.country"
                                        )
                                      ),
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm.$_.get(
                                            _vm.selectedHistory,
                                            "conversation.visitor.country"
                                          )
                                        ) +
                                        "\n                            "
                                    ),
                                  ]
                                ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "userInfo pl-3" }, [
                            _c("div", { staticClass: "userInfo first" }, [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(_vm.$t("message.language")) +
                                  "\n                            "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "userInfo sec" }, [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm.selectedHistory.conversation
                                      .languageCode
                                  ) +
                                  "\n                            "
                              ),
                            ]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "userInfo" }, [
                          _c("div", { staticClass: "userInfo first" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.$t("message.osAndBrowser")) +
                                "\n                        "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "userInfo sec" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm.$_.get(
                                    _vm.selectedHistory,
                                    "conversation.visitor.os"
                                  )
                                ) +
                                "\n                            " +
                                _vm._s(
                                  _vm.$_.get(
                                    _vm.selectedHistory,
                                    "conversation.visitor.browser"
                                  )
                                ) +
                                "\n                        "
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "userInfo" }, [
                          _c("div", { staticClass: "userInfo first" }, [
                            _vm._v("IP"),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "userInfo sec" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm.$_.get(
                                    _vm.selectedHistory,
                                    "conversation.visitor.ipAddress"
                                  )
                                ) +
                                "\n                        "
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "userInfo" }, [
                          _c("div", { staticClass: "userInfo first" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.$t("message.chatId")) +
                                "\n                        "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "userInfo sec" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.selectedHistory.conversation._id) +
                                "\n                        "
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "userInfo" }, [
                          _c("div", { staticClass: "userInfo first" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm.$t("message.customerClientVersion")
                                ) +
                                "\n                        "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "userInfo sec" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm.$_.get(
                                    _vm.selectedHistory,
                                    "conversation.visitor.version.versionStr"
                                  )
                                ) +
                                "\n                        "
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _vm.selectedHistory.conversation.description
                          ? _c("div", { staticClass: "userInfo" }, [
                              _c("div", { staticClass: "userInfo first" }, [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(_vm.$t("message.visitorFeedback")) +
                                    "\n                        "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "userInfo sec" }, [
                                _c(
                                  "p",
                                  {
                                    directives: [
                                      {
                                        name: "b-modal",
                                        rawName: "v-b-modal.visitor-message",
                                        modifiers: { "visitor-message": true },
                                      },
                                    ],
                                    staticStyle: {
                                      "word-wrap": "break-word",
                                      overflow: "hidden",
                                      "text-overflow": "ellipsis",
                                      display: "-webkit-box",
                                      "-webkit-box-orient": "vertical",
                                      "-webkit-line-clamp": "3",
                                      "word-break": "break-all",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm.selectedHistory.conversation
                                            .description
                                        ) +
                                        "\n                            "
                                    ),
                                  ]
                                ),
                              ]),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "userInfo" }, [
                          _c("div", { staticClass: "userInfo first" }, [
                            _vm._v("Note"),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "userInfo sec" }, [
                            _c(
                              "div",
                              { staticClass: "rep-note-element" },
                              [
                                _c("div", { staticClass: "rep-note-name" }, [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(_vm.infoObj.noteSender) +
                                      "\n                                "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("a-textarea", {
                                  on: {
                                    focus: function ($event) {
                                      _vm.infoObj.isEditingOpen = true
                                    },
                                  },
                                  model: {
                                    value: _vm.infoObj.info,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.infoObj, "info", $$v)
                                    },
                                    expression: "infoObj.info",
                                  },
                                }),
                                _vm._v(" "),
                                _vm.infoObj.isEditingOpen
                                  ? _c(
                                      "div",
                                      { staticClass: "rep-note-actions" },
                                      [
                                        _c(
                                          "a-button-group",
                                          { attrs: { size: "small" } },
                                          [
                                            _c("a-button", {
                                              attrs: {
                                                icon: "close",
                                                type: "danger",
                                              },
                                              on: { click: _vm.notSaveInfo },
                                            }),
                                            _vm._v(" "),
                                            _c("a-button", {
                                              attrs: {
                                                icon: "check",
                                                type: "primary",
                                              },
                                              on: { click: _vm.saveInfo },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]),
                        ]),
                      ]),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: "visitor-message",
            title: _vm.$t("message.visitorFeedback"),
          },
        },
        [
          _c(
            "p",
            { staticClass: "my-4", staticStyle: { "word-wrap": "break-word" } },
            [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.selectedHistory.conversation.description) +
                  "\n        "
              ),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      !_vm.isAdmin ? _c("ChatBar", { attrs: { visible: false } }) : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }